// removed by extract-text-webpack-plugin
module.exports = {"test":"_20a6qURNCRTWTLFCKgIcvR"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/style.css
// module id = 409
// module chunks = 38